import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IMyDateModel } from 'angular-mydatepicker';
import { EngineService } from '../_services/engine.service';
import { getUrl } from '../_shared/utils';
import { ConfigCreateModalComponent } from './engine-config-create-modal.component';
import { DialogService } from '../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CueConfig } from '../_models/CueConfig';


@Component({
    selector: 'app-engine-config-management',
    templateUrl: './engine-config-management.component.html',
    styleUrls: ['./engine-config-management.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ConfigManagementComponent implements OnInit {

    // Environment Variables
    baseUrl = getUrl();

    configs: CueConfig[] = [];
    loading = false;
    showing = {};
    copied = {};
    displayInactive = false;

    filteredConfigs: CueConfig[] = [];
    display: CueConfig[] = [];
    searchText = '';

    private bsModalRef: BsModalRef;

    constructor(
        private configService: EngineService,
        private modalService: BsModalService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private spinner: NgxSpinnerService) { }

    ngOnInit() {
        this.loadConfigs();
    }

    filterConfigs(event: IMyDateModel, controlName: string) {
        let temp = this.configs;

        if (this.searchText != null && this.searchText !== '') {
            temp = temp.filter(
                p => (p.name != null ? p.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false) || (p.path != null ? p.path.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false));
        }
        this.display = temp;
    }

    loadConfigs() {
        this.loading = true;
        this.spinner.show();
        this.configService.getConfigs().subscribe(data => {

            const filteredData = data.filter(config => !config.name.startsWith('.'));

            this.configs = filteredData;
            this.display = filteredData;
            this.loading = false;
            this.spinner.hide();
        });
    }

    editConfig(id: number) {

        this.spinner.show();

        this.configService.getConfigById(id)
            .subscribe(
                config => {
                    
                    this.spinner.hide();
                    this.openConfigCreate(config, true);
                },
                error => {

                    this.spinner.hide();
                    this.dialogService.alert("Uh oh!", `Something went wrong trying to retrieve the engine config: ${error.error}`, this.viewRef);
                }
            );
    }

    public openConfigCreate(config: any, editing: boolean = false) {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };

        const initialState = {
            config: config,
            editing
        };

        this.bsModalRef = this.modalService
            .show(
                ConfigCreateModalComponent,
                Object.assign({}, modalConfig, { class: 'modal-lg', initialState }));

            this.bsModalRef.content.hasError.subscribe(
                value => {
                    if (value) {
                        this.displayErrorMessage();
                    } else {
                        this.loadConfigs();
                    }
                });
    }

    private displayErrorMessage() {
        this.dialogService.alert(
          'Unable to Upload',
          'There was an error while trying to upload the config',
        this.viewRef);
      }





}
